export default __webpack_public_path__ + "static/media/qrcode.b3940e82.png";